export default [
    { label:'系统序号:',spanRows:6,type:'input',modelValue:'id'},
    { label:'患者名字:',spanRows:6,type:'input',modelValue:'name'},
    { label:'健康序号:',spanRows:6,type:'input',modelValue:'patientId'},
    { label:'挂号科室:',spanRows:6,type:'select',modelValue:'regDepId',op:'deptOptions'},
    { label:'挂号时间:',spanRows:6,type:'input',modelValue:'regTime' },
    { label:'挂号操作时间:',spanRows:6,type:'input',modelValue:'optTime' },
    { label:'挂号操作员:',spanRows:6,type:'select',modelValue:'regUserId',op:'roleOptions'},
    { label:'挂号方式:',spanRows:6,type:'select',modelValue:'regMode',op:'regModeOption'},
    { label:'挂号进度:',spanRows:6,type:'select',modelValue:'visitState',op:'visitStateOption'},
    { label:'挂号医生:',spanRows:6,type:'select',modelValue:'regDoctorId',op:'doctorOptions' },
    { label:'挂号状态:',spanRows:6,type:'select',modelValue:'regState',op:'regStateOption'},
    { label:'挂号类型:',spanRows:6,type:'select',modelValue:'regTypeId',op:'regOptions'},
    { label:'应收金额:',spanRows:6,type:'input',modelValue:'receivedMoney'},
    { label:'实收金额:',spanRows:6,type:'input',modelValue:'receivableMoney'},
    { label:'优惠金额:',spanRows:6,type:'input',modelValue:'discountMoney'},
    { label:'支付方式:',spanRows:6,type:'select',modelValue:'payType',op:'payTypeOptions'},
    { label:'作废原单据号:',spanRows:6,type:'input',modelValue:'nullifyRegId'},
    { label:'作废时间:',spanRows:6,type:'input',modelValue:'nullifyTime'},
    { label:'作废操作员:',spanRows:6,type:'input',modelValue:'nullifyUserName'},
    { label:'备注:',spanRows:24,type:'input',modelValue:'remake'},
]